import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=c3d83050&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=c3d83050&prod&lang=less"
import style1 from "./Tabs.vue?vue&type=style&index=1&id=c3d83050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d83050",
  null
  
)

export default component.exports